import { Field } from "./field.model";

export class ChoicesField extends Field<string> {
  controlType = "choice";
  options: string[] | { key: string; value: string }[] = [];

  constructor(options: {} = {}) {
    super(options);
    this.options = options["options"] || "";
  }
}
